import { render, staticRenderFns } from "./StoryManage.vue?vue&type=template&id=dbc2b822&scoped=true&"
import script from "./StoryManage.vue?vue&type=script&lang=js&"
export * from "./StoryManage.vue?vue&type=script&lang=js&"
import style0 from "./StoryManage.vue?vue&type=style&index=0&id=dbc2b822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc2b822",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
